import type { Content } from 'pdfmake/interfaces';
import type { ViewBlock } from '@/data/schemas';
import { cm } from '../../theme.pdf';

type SpacerBlock = Extract<ViewBlock, { type: 'spacer' }>;

export function renderSpacerBlock(block: SpacerBlock): Content {
  return {
    text: '',
    margin: [0, 0, 0, (block.size ?? 1) * cm(0.6)],
  };
}
